import React from 'react';
import { XIcon } from 'lucide-react';
interface FacilityLayoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FacilityLayoutModal({
  isOpen,
  onClose
}: FacilityLayoutModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-black/90 animate-fade-in" data-id="element-91">
      {/* Header */}
      <div className="bg-[#1f5070] px-4 py-4 flex items-center justify-between" data-id="element-92">
        <h2 className="text-lg font-bold text-white" data-id="element-93">Facility Layout</h2>
        <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Close facility layout" data-id="element-94">
          <XIcon className="w-6 h-6 text-white" data-id="element-95" />
        </button>
      </div>

      {/* Full Layout Image */}
      <div className="h-[calc(100vh-64px)] overflow-auto bg-white p-6" data-id="element-96">
        <div className="max-w-4xl mx-auto" data-id="element-97">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8PdThQQMcMkM9wLNVrEzR9/court_layout.png" alt="Lamunin Pickleball Facility Layout" className="w-full h-auto rounded-lg shadow-lg" data-id="element-98" />

          {/* Legend */}
          <div className="mt-6 bg-[#f8f9fa] rounded-lg p-4" data-id="element-99">
            <h3 className="text-sm font-bold text-[#1f5070] mb-3" data-id="element-100">
              Court Information
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-101">
              <div data-id="element-102">
                <span className="font-bold text-[#1f5070]" data-id="element-103">Courts 1-4:</span>
                <span className="text-[#666666]" data-id="element-104"> Padel Courts (Indoor)</span>
              </div>
              <div data-id="element-105">
                <span className="font-bold text-[#1f5070]" data-id="element-106">Courts 5-6:</span>
                <span className="text-[#666666]" data-id="element-107">
                  {' '}
                  Pickleball Courts (Indoor)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}